import { Component, Input } from '@angular/core';
import { Helper } from '../../../core/classes/helper';
import { InputComponent } from '../input/input.component';

/**
 * Textarea component to show textarea with label, chars left counter, and validation messages
 *
 * @example
 * <cfe-input-textarea
 *                [control]="formControl"
 *                [label]="'A textarea'"
 *                [id]="'description'"
 *                [rows]="5"
 *                [maxLength]="1000"
 *                [tabIndex]="1"
 *                [disabled]="false"
 *                [notMarkAsRequired]="false">
 * </cfe-input-textarea>
 */

@Component({
	selector: 'cfe-input-textarea',
	templateUrl: './input-textarea.component.html',
	styleUrls: ['./input-textarea.component.scss']
})
export class InputTextareaComponent extends InputComponent {
	/**
	 * Rows of textarea
	 */
	@Input() rows = 5;

	/**
	 * Maxlength of textarea
	 */
	@Input() maxLength: number;

	/**
	 * Placeholder
	 */
	@Input() placeholder = '';

	/**
	 * Charsleft of textarea
	 */
	public charsLeft: number;

	/**
	 * Helper
	 */
	public Helper = Helper;

	constructor() {
		super();
	}

	/**
	 * Lifecycle Hook onInit
	 */
	cfeOnInit() {
		// Init the Chars for Textarea
		this.checkCharsCount();

		// Update on change
		this.control.valueChanges.subscribe(() => {
			this.checkCharsCount();
		});
	}

	/**
	 * Calculate the left chars
	 */
	checkCharsCount() {
		if (this.maxLength) {
			this.charsLeft = this.maxLength;
			if (this.control && this.control.value) {
				this.charsLeft = this.maxLength - this.control.value.length;
			}
		}
	}
}
